import { createSelector } from 'reselect';

import { selectedSchoolSelector } from '../../../reducers/selectors';

const supportedSchoolSelector = createSelector(
  selectedSchoolSelector,

  school => {
    let selectedSchool;
    const supportedSchool = school?.supported === true;
    const blockedSchool = school?.blockedReasons.length > 0;
    if (school.supported === false) selectedSchool = 'unsupportedSchool';
    if (blockedSchool) selectedSchool = 'frenchRegulationBlockedSchool';
    if (school.campuses.length > 1 && supportedSchool && !blockedSchool)
      selectedSchool = 'multipleCampuses';
    if (school.campuses.length === 1 && supportedSchool && !blockedSchool)
      selectedSchool = 'singleCampus';
    return selectedSchool;
  },
);

export default supportedSchoolSelector;
